import { PlotOptions } from "highcharts";

export const lineChartPlotOptionsLine: PlotOptions["line"] = {
  marker: {
    enabled: false,
    states: { hover: { enabled: true, radius: 5 } },
  },
};
